import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CommercialComparisonTable from './CommercialComparisonTable';
import ProductPackage from '../reusable/ProductPackage';

/**
 * ProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {Object}      props.coupon          Coupon object.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {Number}      props.productId       Id number of the product.
 * @param   {Object}      props.productsConfig  Product configurations.
 * @returns {JSX.Element} The component markup.
 */

const CommercialProductPackage = ({ coupon, onSelectPackage, productId, productsConfig }) => {
  const [activeKey, setActiveKey] = useState('3');
  const [packageKey, setPackageKey] = useState('combo');

  const productTable = productsConfig ? (
    <CommercialComparisonTable
      addons={productsConfig.addons}
      industryPackage={productsConfig.packages}
      propertyData={productsConfig.property_data}
      tools={productsConfig.tools}
      usersGeo={productsConfig.users_geo}
    />
  ) : (
    ''
  );

  const productTableMobile = productsConfig ? (
    <CommercialComparisonTable
      addons={productsConfig.addons}
      industryPackage={productsConfig.packages}
      isMobile={true}
      packageKey={packageKey}
      propertyData={productsConfig.property_data}
      tools={productsConfig.tools}
      usersGeo={productsConfig.users_geo}
    />
  ) : (
    ''
  );

  const productPackage = {
    contactText: '',
    contactUrl: null,
    mobilePackageTexts: [],
    packageHeader: 'Cityscope & Lease Expiry Diary',
    packageTexts: null,
    packageTitle: null,
    productId: productId,
    productName: 'commercial',
    table: productTable,
    tableMobile: productTableMobile
  };

  return (
    <ProductPackage
      activeKey={activeKey}
      coupon={coupon}
      onSelectPackage={onSelectPackage}
      packageKey={packageKey}
      productPackage={productPackage}
      productsConfig={productsConfig}
      setActiveKey={setActiveKey}
      setPackageKey={setPackageKey}
    />
  );
};

CommercialProductPackage.propTypes = {
  coupon: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
  productsConfig: PropTypes.object
};

export default CommercialProductPackage;
